import React from 'react';
import Logo from './Logo';
import DropDownUser from './DropDownUser';
import '../../assets/Header.css'

function Header ({tab, onTabClick}) {
  const itemBlue = tab === 'items' ? 'headerBlue borderBlue' : '';

  return (
    <header className="flex items-center justify-between px-6 bg-white sticky top-0 z-10 border-b-[1px] border-gray border-solid pt-1">
      <div className="flex items-center gap-4 flex-nowrap">
        <Logo />
        <button href='' className={`font-bold text-lg tracking-wide px-2 text-left buttonHeight ${itemBlue}`} onClick={() => onTabClick('items')}>Titan Validations</button>
      </div>
        <DropDownUser />
    </header>
  )
}

export default Header;